// extracted by mini-css-extract-plugin
export default {"root":"CustomSections__root--cLTWe","add-section":"CustomSections__add-section--tkDIN","addSection":"CustomSections__add-section--tkDIN"};